/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import React, { useState, useCallback } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { IconButton } from '../../IconButton/IconButton';
import { DocumentsModal } from './DocumentsModal';

export namespace MobileDocumentPicker {
  export interface Props {}
}

const styles = StyleSheet.create({
  modalTrigger: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    margin: 16,
  },
});

export const MobileDocumentsPicker: React.FC<MobileDocumentPicker.Props> = ({}) => {
  const [isDocumentsModalOpen, setIsMobileDocumentsModalOpen] = useState(false);

  const handleOpenDocumentsModal = useCallback(() => setIsMobileDocumentsModalOpen(true), []);
  const handleCloseDocumentsModal = useCallback(() => setIsMobileDocumentsModalOpen(false), []);

  return (
    <>
      <div className={css(styles.modalTrigger)} data-it="MobileDocumentsPicker">
        <IconButton icon={'format_list_bulleted'} onClick={handleOpenDocumentsModal} />
      </div>
      <DocumentsModal isOpen={isDocumentsModalOpen} handleClose={handleCloseDocumentsModal} data-it="DocumentsModal" />
    </>
  );
};
